const LOGIN_URL = 'login/access-token'
const USER_LOGIN_URL = 'user/login/'

const NOTIFICATION_LIST = 'notifications/'
const NOTIFICATION_CLEAR = 'notifications/clear_all'
const ASSESSOR_LIST_URL = 'assessors'
const ADMIN_USER = 'users/'
const ADMIN_REPORT = 'reports'
const MANAGER_USER = 'managers/'
const CLIENT = 'clients/'
const ACCOUNT_APP = 'core/accounting-app'
const BGL = 'bgl/'
const BGL_AUTHORIZE = 'bgl/authorize'
const BGL_TOKEN = 'bgl/fetch-token'
const BGL_TOKEN_UPDATE = 'bgl/update-token'
const FUNDS = '/funds/'
const FOLDERS = 'core/folders/'
const DOCS = 'job-docs'
const JOB = 'job'

const GROUP_LIST = 'core/user-roles/'
const ORGANISATION_LIST_URL = 'organisations'
const ORGANISATION_URL = 'organisation'
const MY_PROFILE = 'users/me'
const MY_PROFILE_IMAGE = 'profile-image'

const COUNTRIES = 'countries'
const ORGANISATION_DATATABLES = 'datatable'

const ACCREDITATION_LIST_URL = 'accreditations'
const RENEW_APPLICATION = 'renew-accreditations'

const apiUrl: { [key: string]: string } = {
  LOGIN_URL,
  USER_LOGIN_URL,
  NOTIFICATION_LIST,
  NOTIFICATION_CLEAR,
  ASSESSOR_LIST_URL,
  ADMIN_USER,
  ADMIN_REPORT,
  GROUP_LIST,
  ORGANISATION_LIST_URL,
  MY_PROFILE,
  MY_PROFILE_IMAGE,
  COUNTRIES,
  ORGANISATION_URL,
  ORGANISATION_DATATABLES,
  ACCREDITATION_LIST_URL,
  RENEW_APPLICATION,
  MANAGER_USER,
  CLIENT,
  ACCOUNT_APP,
  BGL,
  BGL_AUTHORIZE,
  BGL_TOKEN,
  BGL_TOKEN_UPDATE,
  FUNDS,
  JOB,
  FOLDERS,
  DOCS,
}

export default apiUrl
